import React, { Fragment, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { addCourseComment } from "../../../actions/course";

import CourseCommentItem from "./CourseCommentItem";

const CourseComments = ({
  auth: { user },
  isAuthenticated,
  showChat,
  setShowChat,
  comments,
  course,
  purchases,
  text,
  setText,
  addCourseComment,
}) => {
  const inputRef = useRef(null);

  return (
    <Fragment>
      {showChat && (
        <div className="live-stream-side-container border-left grey">
          <div className="container-name">
            <i
              className="far fa-window-close fa-2x red close-window"
              onClick={() => setShowChat(false)}
            ></i>
            <p className="container-title red bold">Course Comments</p>
          </div>
          <div
            className={isAuthenticated ? "all-content" : "all-content-no-auth"}
          >
            {comments && comments.length === 0 ? (
              <div className="empty-side-container">
                <p className="empty-content-alt-dark red bold">No Comments</p>
              </div>
            ) : (
              comments &&
              comments.map((comment) => {
                return (
                  <CourseCommentItem
                    comment={comment}
                    key={comment._id}
                    course={course}
                    user={user}
                    isAuthenticated={isAuthenticated}
                  />
                );
              })
            )}
          </div>
          {purchases &&
            purchases.length > 0 &&
            purchases.map((purchase) => {
              if (purchase.purchase_id === course._id) {
                return (
                  <div>
                    {isAuthenticated && (
                      <form
                        onSubmit={(e) => {
                          e.preventDefault();
                          if (text !== "") {
                            addCourseComment(course, text);
                            setText("");
                            inputRef.current.focus();
                          }
                        }}
                        className="chat-message-container grey"
                      >
                        <div className="type-message-container">
                          <img
                            src={`https://ime.sfo3.cdn.digitaloceanspaces.com/public/uploads/avatars/${
                              user && user.avatar
                            }`}
                            className="chat-avi-user"
                            alt="avatar"
                          />
                          <textarea
                            name="chattextarea"
                            ref={inputRef}
                            rows="10"
                            type="text"
                            className="chat-textarea"
                            placeholder="Type your message here..."
                            onKeyPress={(e) => {
                              if (e.key === "Enter" && text != "") {
                                addCourseComment(course, text);
                                setText("");
                                inputRef.current.focus();
                              }
                            }}
                            onChange={(e) => setText(e.target.value)}
                            value={text}
                          ></textarea>
                        </div>
                        <div className="send-message-container">
                          <button
                            type="submit"
                            className="send-message background-red"
                          >
                            <i className="far fa-paper-plane mx-5"></i>Send
                            Message
                          </button>
                        </div>
                      </form>
                    )}
                  </div>
                );
              }
            })}
        </div>
      )}
    </Fragment>
  );
};

CourseComments.propTypes = {
  addCourseComment: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  isAuthenticated: state.auth.isAuthenticated,
});

export default connect(mapStateToProps, { addCourseComment })(CourseComments);
